/**
 * Redirect legacy Contact / Client Intake routes to CRM with filters
 */

import { Navigate, useLocation } from 'react-router-dom'

export default function HubCrmRedirect({ filter }) {
  const location = useLocation()
  const params = new URLSearchParams(filter || {})
  const existing = new URLSearchParams(location.search)
  for (const [key, value] of existing.entries()) {
    if (!params.has(key)) params.set(key, value)
  }
  const search = params.toString()
  return <Navigate to={`/hub/crm${search ? `?${search}` : ''}`} replace />
}
